import { useEffect, useState } from 'react';

import UserStore from '../../../../stores/UserStore';
import { isMaskedEmail } from '../../../utils';

type SetInitRecipientEmail = (initRecipientEmail: string) => string;

interface RecipientEmailState {
    recpEmail: string;
    setInitRecipientEmail: SetInitRecipientEmail;
}

const useRecipientEmail = (userStore: UserStore): RecipientEmailState => {
    const [recpEmail, setRecpEmail] = useState<string>(null);

    const { currentUserEmail } = userStore;

    useEffect(() => {
        if (currentUserEmail) {
            setRecpEmail(currentUserEmail);
        }
    }, [currentUserEmail]);

    const setInitRecipientEmail = (initRecipientEmail: string): string => {
        // Masked public-link addresses are not usable for Cognito/OTP send.
        const fromLink = isMaskedEmail(initRecipientEmail)
            ? ''
            : (initRecipientEmail || '');
        const recipientEmail = userStore.currentUserEmail
            || fromLink
            || '';
        setRecpEmail(recipientEmail);
        return recipientEmail;
    };

    return {
        recpEmail,
        setInitRecipientEmail,
    };
};

export default useRecipientEmail;
